import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import moment from 'moment-timezone'
import Grid from '@material-ui/core/Grid';
import { Dialog, Tooltip } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { AppHelper } from '../../helpers/AppHelper';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { Toast } from '../../components/Toast';
import { DynamicForm } from '../../common/components/DynamicForm';
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog';
import { DisplayWeblinkPreviewDialog } from '../../components/DisplayWeblinkPreviewDialog';
import { GraphHelper } from '../../common/components/charts/GraphHelper';
import { AppConfig } from '../../AppConfig';
import { DP_DISPLAY_NAME_MAP as exchangeToTitleMap, formatDpName } from '../../data/data';
import { GraphUiHelper } from '../../helpers/GraphUiHelper';
import { SearchBar } from '../../common/components/SearchBar';
import { UiHelper } from '../../common/helpers/UiHelper';
import { PlaybackHistoryFilterBar } from '../../components/PlaybackHistoryFilterBar';
import { Headerbar } from '../../common/components/Headerbar';
import { SingleSelectDropDown } from '../../common/components/SingleSelectDropDown';

const queryString = require('query-string');
const VENUE_FILL_RATE_TIMEZONE = AppConfig.DEFAULT_TIMEZONE || AppConfig.DEFAULT_ZONEINFO
const VENUE_FILL_RATE_TIMEZONE_LABEL = 'CST'
const OTT_DP_VALUES = ['PU', 'IN', 'VS', 'PO']
const PLAYBACK_VIEW_OPTIONS = [
  { key: 'ssp-only', label: 'SSP Only' },
  { key: 'ssp-cms-24-hours', label: 'SSP & CMS - Latest 24 Hr' }
]

const getInitialDateRange = () => {
  const endHourStart = moment().tz(VENUE_FILL_RATE_TIMEZONE).startOf('hour')
  const endTs = endHourStart.clone().subtract(1, 'second').valueOf()
  const startTs = endHourStart.clone().subtract(24, 'hours').valueOf()
  return {
    startTs,
    endTs,
    startHr: String(moment(startTs).tz(VENUE_FILL_RATE_TIMEZONE).hour()),
    endHr: String(endHourStart.hour())
  }
}

const getHourOptions = () => {
  return Array.from({ length: 24 }, (_, hour) => ({
    key: String(hour),
    label: moment({ hour }).format('hh A')
  }))
}

const hasHourValue = (hour) => hour !== undefined && hour !== null && hour !== ''

const getScreenQueryParam = (props = {}) => {
  const query = queryString.parse(props.location && props.location.search ? props.location.search : '')
  const screen = Array.isArray(query.screen) ? query.screen[0] : query.screen
  return screen ? String(screen).trim() : ''
}

export class VenueFillRate extends BaseEntityPage {
  pageKey = 'VenueFillRate';
  pageTitle = Helper.getString('venueFillRate');
  orgId = this.props.match.params.orgId || 'PRODUCT';
  breadCrumbs = [
    { title: Helper.getString('home'), to: this.baseRoute() },
    { title: Helper.getString('venueFillRate') },
  ];
  noAdd = true;
  state = {
    ...getInitialDateRange(),
    stats: [],
    items: [],
    allItems: [],
    venueCode: getScreenQueryParam(this.props),
    viewMode: 'ssp-only',
    tableSearchText: '',
    inProcessSearch: false,
    showDetails: false,
    showToast: false,
    severity: 'info',
    toastMsg: '',
  };



  constructor(props, options) {
    super(props, options);
    this.pageForOrgType = (options || {}).pageForOrgType || null
    this.chartOptions = GraphHelper.getdoughnutChartOptions()
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.state = {
      ...this.state,
      viewMode: this.orgId === 'PRODUCT' ? 'ssp-only' : 'ssp-cms-24-hours'
    }
    this.tableHeadersMap = {
      Content: (current) => this.renderContentThumbnail(current),
      Info: (current) => {
        if (current.isCmsAdsReport) {
          return (
            <div className={css(Styles.infoBlock)}>
              {/* <div><span className={css(Styles.spanValue)}>Title: {current.title || '-'}</span></div> */}
              {current.iType && <div><span className={css(Styles.spanValue)}>{current.iType}</span></div>}
              {/* {current.campaignTitle && <div><span className={css(Styles.spanValue)}>Campaign Title: {current.campaignTitle || '-'}</span></div>} */}
              {/* {current.durationSecs !== undefined && (
                <div>
                  <span className={css(Styles.spanValue)}>Duration: {`${current.durationSecs} Secs`}</span>
                </div>
              )}
              {current.campaignId && (
                <div>
                  <span className={css(Styles.spanValue)}>Campaign ID: {current.campaignId || '-'}</span>
                </div>
              )} */}
            </div>
          )
        }
        const mimeType = (((current && current.mimetype) || AppHelper.getMimeTypeFromUrl(current && (current.adUrl || current.url)) || '')).toLowerCase()
        const mediaTypeLabel = mimeType.startsWith('video/')
          ? 'VIDEO'
          : mimeType.startsWith('image/')
            ? 'IMAGE'
            : 'OTHER'
        const infoParts = [
          current.advertiserDomains && current.advertiserDomains.join(','),
          current.iabCategories && current.iabCategories.join(','),
          current.buyer,
          current.adRating,
          current.campaignNames && current.campaignNames.join(','),
          current.adTitle,
          current.adSystems && current.adSystems.join(','),
        ].filter(Boolean)
        const renderOpt = { hidePop: true, showDropped: true }
        return (
          <div className={css(Styles.infoBlock)}>
            <div>
              <span className={css(Styles.spanValue)}>
                {mediaTypeLabel}
                {this.orgId === 'PRODUCT' && current.durationsecs ? ` | ${current.durationsecs} Secs` : ''}
              </span>
            </div>
            {this.orgId === 'PRODUCT' &&
              <Fragment>
                <div>
                  {current.exchange &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>Exchange: {exchangeToTitleMap[current.exchange] || current.exchange}</span>
                  </Fragment>
                  }
                </div>
                {current.descr &&
                  <div className={css(Styles.descrText)}>
                    {current.descr}
                  </div>
                }
                {current.tags && current.tags.length > 0 &&
                  <div className={css(Styles.tagHolder)}>
                    {current.tags.map((tag, index) => (
                      <span key={`tag_${index}`} className={css(Styles.tagChip)}>
                        {tag}
                      </span>
                    ))}
                  </div>
                }
                {/* {current.createdTs &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>Leased Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.createdTs, format: 'Do MMM YYYY, h:mm a' })}</span>
                  </Fragment>
                } */}
                {current.firstApprovalTs &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>First Approval Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.firstApprovalTs, format: 'Do MMM YYYY, h:mm a' })}</span>
                  </Fragment>
                }
                {current.firstRejectionTs &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>First Rejection Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.firstRejectionTs, format: 'Do MMM YYYY, h:mm a' })}</span>
                  </Fragment>
                }
                {current.stateChangeReason &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>State Change Reason: {current.stateChangeReason}</span>
                  </Fragment>
                }
                <div>
                  {infoParts.join(' | ')}
                </div>
              </Fragment>
            }
            {/* {GraphUiHelper.renderCreativeStats(current, renderOpt)} */}
          </div>
        )
      },
      // Exchange: (current) => <span>{formatDpName(current.dp)}</span>,
      // 'Duration (seconds)': (current) => <span>{current.durationsecs}</span>,
      // 'Played Time': (current) => <span>{this.formatPlayedTime(current.popTs)}</span>
    }
    if(this.pageForOrgType !== 'PARTNER') {
      this.tableHeadersMap['Played Time'] = (current) => <span>{this.formatPlayedTime(current.popTs)}</span>
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.headerActions = this.orgId === 'PRODUCT'
      ? [
        {
          label: 'Last 24 hours',
          icon: 'refresh',
          type: 'icon-mobile',
          onClick: () => this.onLast24HoursSearch()
        }
      ]
      : []
    this.toFetch = []
  }

  componentDidMount() {
    if (!getScreenQueryParam(this.props)) {
      this.setState({
        fetchState: ApiHelper.State.READY
      })
      return
    }

    this.toFetch = this.makeFetches()
    this.setState({ inProcessSearch: true }, () => {
      this.fetchItems()
    })
  }

  formatPlayedTime = (popTs) => {
    return popTs ? `${Helper.formatDate2({ utcTimestamp: popTs, zone: VENUE_FILL_RATE_TIMEZONE, format: 'Do MMM YYYY, h:mm a' })} ${VENUE_FILL_RATE_TIMEZONE_LABEL}` : ''
  }

  formatDuration = (durationSecs = 0) => {
    const totalSeconds = Math.round(Number(durationSecs) || 0)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`
    if (minutes > 0) return `${minutes}m ${seconds}s`
    return `${seconds}s`
  }

  makeFetches = () => {
    const { startTs, endTs, startHr, endHr, venueCode, viewMode } = this.state;
    const queryParams = {}

    if (startTs) queryParams.startTs = startTs
    if (endTs) queryParams.endTs = endTs
    if (viewMode === 'ssp-only' && hasHourValue(startHr)) queryParams.startHr = startHr
    if (viewMode === 'ssp-only' && hasHourValue(endHr)) queryParams.endHr = endHr
    if (venueCode) queryParams.venueCode = venueCode.trim()
    if (viewMode) queryParams.viewType = viewMode

    return [{ method: 'GET', paths: ['miscs', 'venue-fill-rate'], queryParams }];
  };

  updateScreenQueryParam = (venueCode = '') => {
    const { history, location } = this.props
    if (!history || !location) return

    const query = queryString.parse(location.search || '')
    query.screen = venueCode
    const search = queryString.stringify(query)

    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : ''
    })
  }

  onError = (toastMsg) => {
    this.setState({
      showToast: true,
      severity: 'error',
      toastMsg
    });
  }

  getToast = () => {
    return (
      <Toast
        open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  normalizePlaybackItem = (item = {}) => {
    const adMetadata = item.adMetadata || {}
    const crInfo = item.crInfo || {}

    return {
      ...item,
      adUrl: adMetadata.asset_url || item.url,
      frameUrls: adMetadata.frame_urls || [],
      exchange: item.exchange || item.dp,
      advertiserDomains: crInfo.advertiserDomains || item.advertiserDomains || [],
      adTechPartners: crInfo.adTechPartners || item.adTechPartners || [],
      orientation: crInfo.orientation || item.orientation,
      adSystems: crInfo.adSystems || item.adSystems || [],
      adRating: crInfo.adRating || item.adRating,
      campaignNames: crInfo.campaignNames || item.campaignNames || [],
      pricingCurrency: crInfo.pricingCurrency || item.pricingCurrency,
      pricingCpm: crInfo.pricingCpm || item.pricingCpm,
      adTitle: crInfo.adTitle || item.adTitle,
      identifiers: crInfo.identifiers || item.identifiers,
      mimetype: item.mimetype || crInfo.mimetype || adMetadata.type || '',
      descr: adMetadata.analysis_notes || item.descr,
      descr2: adMetadata.extracted_text || item.descr2,
      tags: adMetadata.tags || item.tags || [],
      polSocScore: adMetadata.political_social_ad_likelihood !== undefined ? adMetadata.political_social_ad_likelihood : item.polSocScore,
      admJbStatus: adMetadata.status || item.admJbStatus,
      advertisedProduct: adMetadata.advertised_product || item.advertisedProduct,
      contactEmail: adMetadata.contact_email,
      contactNum: adMetadata.contact_num,
      contactWebsite: adMetadata.contact_website,
      jobId: adMetadata.job_id,
      // metadata: adMetadata.metadata || item.metadata,
      // stateChangeReason: item.stateChangeReason || item.adDropReason,
      crInfo,
      adMetadata,
    }
  }

  onFetchSuccess = (results) => {
    const result = results[0] || {}
    const dpSummary = result.dpSummary || {}
    const includesCmsAds = this.state.viewMode === 'ssp-cms-24-hours'
    const playbackItems = (result.items || [])
      .map(this.normalizePlaybackItem)
      .filter((item) => (item.dp || '').toUpperCase() !== 'CMS')
      .sort((a, b) => (Number(b.popTs) || 0) - (Number(a.popTs) || 0))
    const cmsAdsItems = (includesCmsAds && Array.isArray(result.cmsAdsReport) ? result.cmsAdsReport : [])
      .map((item, index) => ({
        ...item,
        isCmsAdsReport: true
      }))
    const allItems = [...playbackItems, ...cmsAdsItems]

    this.setState({
      items: this.filterItemsByTableSearch(allItems, this.state.tableSearchText),
      allItems,
      dpGraphData: [
        this.makeDpSummaryDoughnutData({
          dpSummary,
          metric: 'played',
          chartTitle: 'Ads Count Summary',
          formatValue: (value) => AppHelper.formatNumberStats(value)
        }),
        this.makeDpSummaryDoughnutData({
          dpSummary,
          metric: 'totalDuration',
          chartTitle: 'Ads Duration Summary',
          formatValue: this.formatDuration
        })
      ],
      inProcessSearch: false,
    });
  };

  filterItemsByTableSearch = (items = [], searchText = '') => {
    const trimmed = String(searchText || '').trim().toLowerCase()
    if (!trimmed) return items

    return items.filter((item) => {
      const searchableValues = [
        item.descr,
        item.dp,
        item.exchange,
        exchangeToTitleMap[item.exchange] || item.exchange,
        exchangeToTitleMap[item.dp] || item.dp,
        item.buyer,
        item.adRating,
        item.adTitle,
        item.durationsecs,
        item.stateChangeReason,
        item.adDropReason,
        item.descr2,
        item.advertisedProduct,
        item.creativeId,
        item.venueCode,
        item.advertiserDomains && item.advertiserDomains.join(' '),
        item.iabCategories && item.iabCategories.join(' '),
        item.campaignNames && item.campaignNames.join(' '),
        item.adSystems && item.adSystems.join(' '),
        item.adTechPartners && item.adTechPartners.join(' '),
        item.tags && item.tags.join(' ')
      ].filter(Boolean)

      return searchableValues.some((value) => String(value).toLowerCase().includes(trimmed))
    })
  }

  onTableSearch = (searchText) => {
    this.setState((prevState) => ({
      tableSearchText: searchText,
      items: this.filterItemsByTableSearch(prevState.allItems, searchText)
    }))
  }

  onLast24HoursSearch = () => {
    const venueCode = (this.state.venueCode || getScreenQueryParam(this.props) || '').trim()

    if (!venueCode) {
      this.onError('Provide screen code')
      return
    }

    const dateRange = getInitialDateRange()
    if (this.tableSearchBarComponent) this.tableSearchBarComponent.clearSearch()

    this.setState(
      {
        ...dateRange,
        venueCode,
        tableSearchText: '',
        inProcessSearch: true
      },
      () => {
        this.updateScreenQueryParam(venueCode)
        this.toFetch = this.makeFetches()
        this.fetchItems()
      }
    )
  }


  getDpSummaryGraphPalette = () => [
    '#0057FF',
    '#FF9F1C',
    '#7B2CFF',
    '#00B3FF',
    '#FF4D8D',
    '#312E81',
    '#FFC300',
    '#8B5CF6',
    '#0891B2',
    '#C026D3',
    '#D97706',
    '#475569',
    '#9333EA',
    '#FBBF24',
    '#38BDF8',
    '#B45309',
    '#6B21A8',
    '#64748B'
  ]

  makeDpSummaryDoughnutData = ({ dpSummary = {}, metric, chartTitle, formatValue }) => {
    const values = Object.keys(dpSummary)
      .map((key) => ({
        label: key,
        value: dpSummary[key] && dpSummary[key][metric] ? Number(dpSummary[key][metric]) : 0
      }))
      .filter((item) => item.value > 0)

    const palette = this.getDpSummaryGraphPalette()
    const colors = values.map((item, index) => palette[index % palette.length])
    const data = values.map((item) => item.value)

    return {
      chartTitle,
      data: {
        labels: values.map((item) => `${formatDpName(item.label)} (${formatValue ? formatValue(item.value) : AppHelper.formatNumberStats(item.value)})`),
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderColor: colors,
            hoverBackgroundColor: colors,
            borderWidth: 0
          }
        ]
      },
      hasDataMoreThanZero: data.some((value) => value > 0)
    }
  }

  getPreviewMimeType = (current = {}) => {
    const mediaUrl = this.getPreviewUrl(current)
    const inferredMimeType = AppHelper.getMimeTypeFromUrl(mediaUrl) || AppHelper.getMimeTypeFromUrl(current.contentName)
    const itemType = String(current.iType || '').toUpperCase()

    if (current.mimetype || inferredMimeType) return current.mimetype || inferredMimeType
    if (itemType === 'VIDEO') return 'video/mp4'
    if (itemType === 'IMAGE' || itemType === 'QRWEBLINK') return 'image/jpeg'
    return ''
  }

  getPreviewUrl = (current = {}) => {
    return current.adUrl || current.url || current.content || ''
  }

  renderContentThumbnail = (current = {}) => {
    if (current.isCmsAdsReport) {
      if (current.iType === 'VIDEO') {
        return AppUiHelper.renderVideoThumbnailCustomStyle(current, {}, { _IMAGEFIT: false })
      } else if (current.iType === 'WEBLINK') {
        return <i alt={Helper.getString('assetImageAlt')} className={'material-icons-outlined ' + css(Styles.icons)}>http</i>
      }
      return AppUiHelper.itemImage({
        ...current,
        _IMAGEFIT: false,
        image: current.iType === 'IMAGE' || current.iType === 'QRWEBLINK' ? current.content : undefined
      })
    }

    const mimeType = this.getPreviewMimeType(current).toLowerCase()
    const isVideo = mimeType.startsWith('video/')
    const isImage = mimeType.startsWith('image/')
    const frameUrl = current.frameUrls && current.frameUrls[0]
    const previewUrl = this.getPreviewUrl(current)
    let mediaUrl = previewUrl

    if (isVideo) {
      mediaUrl = frameUrl || previewUrl
    } else if (isImage) {
      mediaUrl = previewUrl
    }

    if (isVideo) {
      return AppUiHelper.renderVideoThumbnailCustomStyle(
        { content: mediaUrl },
        {},
        { _IMAGEFIT: false }
      )
    }

    if (isImage) {
      return AppUiHelper.itemImage({
        ...current,
        _IMAGEFIT: false,
        image: mediaUrl
      })
    }

    return <i className={'material-icons-outlined ' + css(Styles.icons)}>insert_drive_file</i>
  }

  generateTableMap = (items = {}) => {
    const map = {};
    Object.keys(items).forEach((key) => {
      if (key !== 'id') {
        map[items[key]] = (current) => <div>{current[key]}</div>;
      }
    });
    return map;
  };

  onTableValue = (current, index) => {
    if (!this.tableHeaders[index]) return '';
    return this.tableHeadersMap[this.tableHeaders[index]](current);
  };

  getDateTimeFormDefinition = () => {
    const isSspOnly = this.state.viewMode === 'ssp-only'
    const fields = [
      {
        key: 'startTs',
        type: 'date',
        label: `${isSspOnly ? 'Start Date' : 'Date'} (${VENUE_FILL_RATE_TIMEZONE_LABEL})`,
        hint: 'Provide start date',
        value: this.state.startTs,
        // eslint-disable-next-line camelcase
        v_required: { value: true, err: 'Provide start date' },
        placement: 'left',
        clearable: true
      }
    ]

    if (isSspOnly) {
      fields.push(
        {
          key: 'endTs',
          type: 'date',
          label: `End Date (${VENUE_FILL_RATE_TIMEZONE_LABEL})`,
          hint: 'Provide end date',
          value: this.state.endTs,
          // eslint-disable-next-line camelcase
          v_required: { value: true, err: 'Provide end date' },
          placement: 'right',
          clearable: true
        },
        {
          key: 'startHr',
          type: 'select',
          label: `Start Hour (${VENUE_FILL_RATE_TIMEZONE_LABEL})`,
          hint: 'Provide start hour',
          value: this.state.startHr,
          options: getHourOptions(),
          // eslint-disable-next-line camelcase
          v_required: { value: true, err: 'Provide start hour' },
          placement: 'left'
        },
        {
          key: 'endHr',
          type: 'select',
          label: `End Hour (${VENUE_FILL_RATE_TIMEZONE_LABEL})`,
          hint: 'Provide end hour',
          value: this.state.endHr,
          options: getHourOptions(),
          // eslint-disable-next-line camelcase
          v_required: { value: true, err: 'Provide end hour' },
          placement: 'right'
        }
      )
    }

    fields.push({
      key: 'venueCode',
      type: 'edit_text',
      label: 'Screen (eg: DD-886547)',
      hint: 'Search by screen',
      value: this.state.venueCode,
      // eslint-disable-next-line camelcase
      v_required: { value: true, err: 'Provide screen' },
      placement: isSspOnly ? 'left' : 'right'
    })

    return {
      title: '',
      formType: 'edit',
      ctaButtonText: 'Search',
      steps: [{ fields }]
    }
  }

  onDateTimeSearch = (data = {}, onComplete) => {
    const formData = data.formData || data
    const caller = data.caller
    const setFormStatus = (success, message = '') => {
      if (caller) caller.setState({ success, message, inProcess: false })
    }
    const isSingleDay = this.state.viewMode !== 'ssp-only'
    const isFullDay = this.state.viewMode === 'ssp-cms-24-hours'
    const startDate = formData.startTs
    const endDate = isSingleDay ? startDate : formData.endTs
    const startHr = isFullDay ? '0' : formData.startHr
    const endHr = isFullDay ? '0' : formData.endHr
    const venueCode = (formData.venueCode || '').trim()
    // const maxDurationMs = 24 * 60 * 60 * 1000
    const selectedStartDate = moment(Number(startDate)).tz(VENUE_FILL_RATE_TIMEZONE)
    const selectedEndDate = moment(Number(endDate)).tz(VENUE_FILL_RATE_TIMEZONE)

    if (!startDate || !endDate || !selectedStartDate.isValid() || !selectedEndDate.isValid()) {
      this.onError(!startDate || !selectedStartDate.isValid() ? 'Provide start date' : 'Provide end date')
      return
    }

    if (!venueCode) {
      this.onError('Provide screen code')
      return
    }

    if (venueCode.includes(',')) {
      this.onError(Helper.getString('deviceActivitySearchError'))
      return
    }

    if (!hasHourValue(startHr) || !hasHourValue(endHr)) {
      this.onError(!hasHourValue(startHr) ? 'Provide start hour' : 'Provide end hour')
      /* const message = !hasHourValue(startHr) ? 'Provide start hour' : 'Provide end hour'
      caller.setState({
        success: false,
        message,
        inProcess: false
      })
      this.onError(message) */
      return
    }

    const startDateTime = selectedStartDate.clone().hour(Number(startHr)).minute(0).second(0).millisecond(0)
    const endDateTime = selectedEndDate.clone().hour(Number(endHr)).minute(0).second(0).millisecond(0).subtract(1, 'second')

    if (endDateTime.valueOf() <= startDateTime.valueOf() && selectedStartDate.isSame(selectedEndDate, 'day')) {
      endDateTime.add(1, 'day')
    }

    if (endDateTime.valueOf() < startDateTime.valueOf() || endDateTime.valueOf() - startDateTime.valueOf() > 24 * 60 * 60 * 1000) {
      this.onError('Duration should not be more than 24 hours')

      /* if (endTs < startTs) {
      caller.setState({
        success: false,
        message: 'End datetime should be after start datetime',
        inProcess: false
      }) */
      return
    }

    /* if (endTs - startTs > maxDurationMs) {
      const message = 'Duration should not be more than 24 hours'
      caller.setState({
        success: false,
        message,
        inProcess: false
      })
      this.onError(message)
      return
    }

    if (venueCode.includes(',')) {
      caller.setState({
        success: false,
        message: Helper.getString('deviceActivitySearchError'),
        inProcess: false
      })
      return
    }

    caller.setState({
      success: true,
      message: '',
      inProcess: false
    }) */

    this.setState(
      {
        startTs: startDateTime.valueOf(),
        endTs: endDateTime.valueOf(),
        startHr,
        endHr,
        venueCode,
        inProcessSearch: true
      },
      () => {
        this.updateScreenQueryParam(venueCode)
        this.toFetch = this.makeFetches();
        this.fetchItems();
        if (onComplete) onComplete();
      }
    )
  }

  renderPlaybackViewSelect = () => {
    return (
      <SingleSelectDropDown
        onSinglePickerFilter={(event) => this.setState({ viewMode: event.target.value })}
        singleSelectPicker={{
          defaultValue: this.state.viewMode,
          options: PLAYBACK_VIEW_OPTIONS.map((option) => ({ key: option.key, value: option.label }))
        }}
        inputContainer={Styles.headerViewSelect}
      />
    )
  }

  // renderHeaderbar = () => {
  //   return (
  //     <Headerbar
  //       pageKey={this.pageKey}
  //       title={this.pageTitle}
  //       actions={this.headerActions}
  //       actionComponents={this.orgId === 'PRODUCT' ? [this.renderPlaybackViewSelect()] : []}
  //       breadCrumbs={this.breadCrumbs}
  //     />
  //   )
  // }


  renderAboveTable = () => {
    return (
      <div className={css(Styles.renderAboveTable)}>
        <div className={css(Styles.dateTimeFormContainer)}>
          <DynamicForm
            key={`playback-history-form-${this.state.viewMode}`}
            customSubmit={this.onDateTimeSearch}
            formDefinition={this.getDateTimeFormDefinition()}
          />
        </div>
        {/* {this.orgId === 'PRODUCT'
          ? <div className={css(Styles.dateTimeFormContainer)}>
            <DynamicForm
              key={`playback-history-form-${this.state.viewMode}`}
              customSubmit={this.onDateTimeSearch}
              formDefinition={this.getDateTimeFormDefinition()}
            />
          </div>
          : <PlaybackHistoryFilterBar
            key={`playback-history-filter-${this.state.viewMode}`}
            viewMode={this.state.viewMode}
            startTs={this.state.startTs}
            endTs={this.state.endTs}
            startHr={this.state.startHr}
            endHr={this.state.endHr}
            venueCode={this.state.venueCode}
            timezone={VENUE_FILL_RATE_TIMEZONE}
            timezoneLabel={VENUE_FILL_RATE_TIMEZONE_LABEL}
            inProcess={this.state.inProcessSearch}
            onFilter={this.onDateTimeSearch}
          />
        } */}
        {this.orgId === 'PRODUCT' &&
          <Fragment>
            {this.state.dpGraphData && this.state.dpGraphData.length > 0 &&
              <Grid className={css(Styles.chartsContainer)} container spacing={2}>
                {this.state.dpGraphData.map((graphData, index) => (
                  <Grid item className={css(Styles.eachChartHolder)} xs={12} md={4} key={graphData.chartTitle || index}>
                    <div className={css(Styles.chartOuterWrap)}>
                      <div className={css(Styles.chartBlock)}>
                        <div className={css(Styles.chartTitle)}>{graphData.chartTitle}</div>
                        {graphData.hasDataMoreThanZero === false ?
                          <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                          <Doughnut className={css(Styles.chartCanvas)} data={graphData.data} options={this.chartOptions} width={100} height={100} />}
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>
            }
            <div className={css(Styles.tableSearchWrap)}>
              <SearchBar
                ref={(child) => (this.tableSearchBarComponent = child)}
                hint='Search creatives by exchange, tag…'
                inProcessSearch={false}
                callSearchOnEmptyText={true}
                onSearch={this.onTableSearch}
                searchText={this.state.tableSearchText}
                resetFilterText='Reset Filter'
                showRecentButtonText='Search'
              />
            </div>
          </Fragment>
        }
        {this.getToast()}
        {this.renderDetailsDialog()}
        {this.renderPreviewDialogs()}
      </div>
    );
  };

  renderPreviewDialogs() {
    if (!this.state.preview || !this.state.current) return '';
    if (this.state.current.isCmsAdsReport && this.state.current.iType === 'WEBLINK') {
      return (
        <DisplayWeblinkPreviewDialog
          title={this.state.current.title}
          isOpen={this.state.preview ? true : false}
          adLink={this.state.current.contentName}
          onClosed={() => this.setState({ preview: undefined })}
        />
      )
    }
    return (
      <DisplayPreviewDialog
        isOpen={this.state.preview ? true : false}
        adLink={this.getPreviewUrl(this.state.current)}
        mediaType={this.getPreviewMimeType(this.state.current)}
        onClosed={() => this.setState({ preview: undefined })}
      />
    )
  }

  previewButton(current) {
    if (!this.getPreviewUrl(current)) return ''
    return (
      <Tooltip title='Preview' placement='top-start' key={(current.id || current.__index) + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  infoButton(current) {
    if (!OTT_DP_VALUES.includes(current.dp)) return ''
    return (
      <Tooltip title='Info' placement='top-start' key={(current.id || current.__index) + 'Info'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => { this.setState({ showDetails: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  formatDetailValue(key, value) {
    if (value === undefined || value === null || value === '') return '-'
    if (key === 'createdTs' || key === 'firstApprovalTs' || key === 'firstRejectionTs' || key === 'popTs') {
      return Helper.formatTimestamp(value)
    }
    if (typeof value === 'boolean') return value ? 'true' : 'false'
    if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : '-'
    if (typeof value === 'object') return JSON.stringify(value, null, 2)
    return value
  }

  getDetailMeta = () => {
    return {
      advertiserDomains: {
        title: 'Advertiser Domains',
        descr: 'Website domains associated with the advertiser or brand being promoted. Helps identify the advertiser behind the creative (e.g., tangluck.com, sharecare.com).'
      },
      iabCategories: {
        title: 'IAB Categories',
        descr: 'Standard IAB industry categories assigned to the ad content, such as Automotive, Business, Sports, Entertainment, etc.'
      },
      durationsecs: {
        title: 'Ad Duration',
        descr: 'Length of the video creative in seconds. Common values are 15, 30, and 60 seconds.'
      },
      mimetype: {
        title: 'Media Type',
        descr: 'Technical format of the creative asset, such as video/mp4, image/jpeg, or image/png.'
      },
      orientation: {
        title: 'Orientation',
        descr: 'Creative layout orientation derived from asset dimensions. Typical values are landscape, portrait, or square.'
      },
      exchange: {
        title: 'Exchange',
        descr: 'Advertising exchange or SSP that delivered the ad. Examples include PO (Place Exchange OTT), PU (Publica), VS (Vistar), and IN (Indicue).'
      },
      publisherDomains: {
        title: 'Publisher Domains',
        descr: 'Publisher, inventory, or content-owner domains associated with where the ad was served or intended to run.'
      },
      adSystems: {
        title: 'Ad Systems',
        descr: 'Ad-serving platforms or technologies involved in generating or delivering the VAST response, such as AdServer, FreeWheel, Google DCM/DBM, or Vesta.'
      },
      buyer: {
        title: 'Buyer',
        descr: 'Buyer, advertiser account, DSP account, or entity that purchased the advertising impression.'
      },
      buyerSeat: {
        title: 'Buyer Seat',
        descr: 'Seat, account, or buying platform through which the buyer participated in the auction or transaction.'
      },
      campaignNames: {
        title: 'Campaign Name',
        descr: 'Campaign name or campaign identifier associated with the creative and advertising purchase.'
      },
      pricingCpm: {
        title: 'CPM',
        descr: 'Cost Per Mille (cost per 1,000 impressions) associated with the ad transaction or winning bid.'
      },
      adTechPartners: {
        title: 'Ad Tech Partners',
        descr: 'Third-party technology vendors involved in ad serving, measurement, verification, attribution, fraud detection, or analytics.'
      },
      adTitle: {
        title: 'Ad Title',
        descr: 'Human-readable title or name of the creative as provided in the VAST response.'
      },
      descr: {
        title: 'Analysis of the Ad'
      },
      descr2: {
        title: 'Text Extracted from Frames'
      },
      polSocScore: {
        title: 'Political/Social Sensitivity Score (0-10)'
      },
      tags: {
        title: 'Tags'
      },
      admJbStatus:{
        title: 'Ad Analysis Status'
      },
      state: {
        title: 'State',
        descr: 'Whether ad is approved or rejected based on the content'
      },
      adRating: {
        title: 'Ad Rating',
        descr: 'Content suitability or audience rating assigned to the ad, such as G, PG, T, or other exchange-specific ratings.'
      },
      pricingCurrency: {
        key: 'pricingCurrency',
        title: 'Currency',
        descr: 'Currency used for CPM and pricing values associated with the ad transaction. Common values include USD, EUR, GBP, INR, and other ISO currency codes.'
      },
      brCalc:{
        title: 'Bitrate'
      },
    }
  }

  getVisibleDetailKeys = () => {
    return [
      // 'creativeId',
      'venueCode',
      'durationsecs',
      'mimetype',
      'brCalc',
      'orientation',
      'state',
      'exchange',
      'descr',
      'descr2',
      'tags',
      'polSocScore',
      'admJbStatus',
      'advertiserDomains',
      'adSystems',
      'campaignNames',
      'pricingCpm',
      'pricingCurrency',
      'adTechPartners',
      'adTitle',
      'adRating',
      // 'frameUrls',
      // 'createdTs',
      // 'firstApprovalTs',
      // 'firstRejectionTs',
      // 'popTs',
      // 'popStatus',
      // 'adDropReason'
    ]
  }

  renderDetailsDialog() {
    if (!this.state.showDetails || !this.state.current) return ''
    const current = this.state.current
    const detailMeta = this.getDetailMeta()
    const detailRows = this.getVisibleDetailKeys().filter((key) => current[key] !== undefined).map((key) => {
      const value = this.formatDetailValue(key, current[key])
      const isMultiline = typeof value === 'string' && value.indexOf('\n') > -1
      const meta = detailMeta[key] || {}
      return (
        <div className={css(Styles.detailRow)} key={key}>
          <div className={css(Styles.detailKey)}>
            <div>{meta.title || key}</div>
            {meta.descr && <div className={css(Styles.detailDescr)}>{meta.descr}</div>}
          </div>
          <div className={css(Styles.detailValue)}>
            {isMultiline ? <pre className={css(Styles.detailPre)}>{value}</pre> : value}
          </div>
        </div>
      )
    })

    return (
      <Dialog
        open={this.state.showDetails ? true : false}
        aria-labelledby='creative-details'
        fullWidth={true}
        maxWidth='md'
        classes={{
          root: css(Styles.dialogRoot),
          paper: css(Styles.dialogPaper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <button className={css(Styles.modalCloseButton)} onClick={() => this.setState({ showDetails: false })}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.detailContent)}>
          {detailRows}
        </div>
      </Dialog>
    )
  }

  exchangeCreativeButton(current) {
    if (!current.creativeId) return ''
    const isSupportedDp = OTT_DP_VALUES.includes(current.dp)
    const isApiDeviceCreative = current.deviceType === 'API' && current.groupId

    if (!isSupportedDp && !isApiDeviceCreative) return ''

    const destination = isApiDeviceCreative
      ? `/admin/partners/${current.groupId}/creatives?id=${current.creativeId}`
      : `/admin/exchange-creatives?id=${current.creativeId}`

    return (
      <Tooltip title='Review Creative' placement='top-start' key={(current.id || current.__index) + 'ExchangeCreative'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i
            className='material-icons-outlined'
            style={{ fontSize: 20 }}
            onClick={() => window.open(destination, '_blank')}
          >
            launch
          </i>
        </span>
      </Tooltip>
    )
  }

  onActions = (current) => {
    if (this.orgId !== 'PRODUCT' || current.isCmsAdsReport) return [this.previewButton(current)]
    const actions = [this.infoButton(current), this.previewButton(current)]
    const exchangeCreativeButton = this.exchangeCreativeButton(current)
    if (exchangeCreativeButton) actions.push(exchangeCreativeButton)
    return actions
  }
}

const Styles = StyleSheet.create({
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  searchContainer:{
    width:'100%'
  },
  dateTimeFormContainer: {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: '12px 16px'
  },
  headerViewSelect: {
    minWidth: '250px !important',
    maxWidth: '45vw !important'
  },
  actionIconImage: {
    width: 20,
    height: 20
  },
  icons: {
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  statsInnerContainer: {
    display: 'flex',
    gap: 15,
    borderBottom: '1px solid #d7d7d7b5',
    padding: '5px 0px',
    width: 'max-content'
  },
  dpText: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValueText: {
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValues: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  venueColumn: {
    display: 'flex',
    gap: 7,
    flexDirection: 'column'
  },
  spanValue: {},
  img: {
    height: 30,
  },
  line2: {
    fontSize: 12,
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  fullWidth: {
    width: '100%',
  },
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    '@media (max-width: 1025px)': {
      width: '97vw !important'
    }
  },
  eachChartHolder: {
  },
  eachChartHolder2: {
    width: '100%'
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  tableSearchWrap: {
    width: '100%',
    marginBottom: 4
  },
  chartOuterWrap: {
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartOuterWrap2: {
    background: '#fff',
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    height: 160
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas: {
    marginBottom: 10
  },
  statsHolder: {
    padding: '0 10px'
  },
  tagHolder: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    margin: '6px 0'
  },
  descrText: {
    marginTop: 6,
    marginBottom: 6
  },
  tagChip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 999,
    backgroundColor: '#F3F4F6',
    color: '#222222',
    fontSize: 12,
    lineHeight: 1.2
  },
  infoBlock: {
    display: 'flex !important',
    flexDirection: 'column',
    maxWidth: 500,
    fontSize: 12,
    gap: 5
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  dialogRoot: {
    zIndex: 13000
  },
  dialogPaper: {
    borderRadius: AppTheme.borderRadius
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  detailContent: {
    padding: '10px 30px 30px 30px',
    maxHeight: '70vh',
    overflowY: 'auto'
  },
  detailRow: {
    display: 'grid',
    gridTemplateColumns: '260px minmax(0, 1fr)',
    gap: 16,
    padding: '10px 0',
    borderBottom: '1px solid #eeeeee',
    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
      gap: 4
    }
  },
  detailKey: {
    color: '#5f6368',
    fontSize: 13,
    fontWeight: 600,
    wordBreak: 'break-word'
  },
  detailDescr: {
    marginTop: 4,
    color: '#8a8f94',
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1.4
  },
  detailValue: {
    color: '#222222',
    fontSize: 13,
    lineHeight: 1.5,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  detailPre: {
    margin: 0,
    fontFamily: 'Red Hat Display, sans-serif',
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/VenueFillRate.js